import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetAppointmentsByProjectRequest,
  GetAppointmentsByProjectResponse,
} from "../../models/GetAppointmentsByProject.model";
import { environment } from "../../environments";

const API_URL = environment.apiUrl;

export const getAppointmentsByProject = createAsyncThunk<
  GetAppointmentsByProjectResponse,
  GetAppointmentsByProjectRequest,
  { rejectValue: string }
>(
  "appointment/getAppointmentsByProject",
  async (request, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}Appointment/GetAppointmentsByProject`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      });

      const res = await response.json();
      
      if (!response.ok) {
        return rejectWithValue(res.Message || "שגיאה בקבלת פגישות לפי פרויקט");
      }

      return res;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.Message || "שגיאה בקבלת פגישות לפי פרויקט"
      );
    }
  }
);